import * as React from "react";
import moment from "moment";
import * as _ from "lodash";
import { Row, Col, Typography } from "antd";

import { Epoch } from "@ctra/utils";
import styles from "./DateRange.module.less";

const { Text } = Typography;

export interface DateRangeProps {
  /**
   * Start date (as epoch)
   */
  startEpoch: number;
  /**
   * End date (as epoch)
   */
  endEpoch: number;
  /**
   * Current date (as epoch)
   */
  now?: number;
  /**
   * Is slider visible
   */
  slider?: boolean;
}

/**
 * Value indicator with small print explanation
 * @constructor
 */
const DateRange: React.FC<DateRangeProps> = ({ slider = true, ...props }) => {
  /**
   * Convert ms epoch values to internal format
   */
  const {
    startEpoch,
    endEpoch,
    now = Epoch.load(+moment())
  } = _.mapValues(props, Epoch.load) as unknown as DateRangeProps;

  /**
   * Calculate the progress
   */
  const progress = Math.min((now - startEpoch) / (endEpoch - startEpoch), 1) * 100;

  return (
    <Row align="middle" gutter={slider ? 0 : 10}>
      <Col>
        <Text type="secondary">{Epoch.asMoment(startEpoch).format("LL")}</Text>
      </Col>
      {slider ? (
        <Col flex="auto" className={styles.Slider}>
          <div className={styles.Progress} style={{ width: `${progress}%` }} />
        </Col>
      ) : (
        "-"
      )}
      <Col>
        <Text type="secondary">{Epoch.asMoment(endEpoch).format("LL")}</Text>
      </Col>
    </Row>
  );
};

export default DateRange;
